module.exports = __webpack_public_path__ + "img/maui.5fac6a81.jpg";